import React, { Fragment } from "react"
import { withStyles } from "@material-ui/core/styles"
import { StaticQuery, graphql } from "gatsby"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import "typeface-roboto"
import faviconIcon from "../../assets/images/favicon.ico"
import AnonymousLayout from "./AnonymousLayout"
import AuthLayout from "./AuthLayout"
import "../../sass/style.scss"
const styles = theme => ({
  root: {
    paddingTop: theme.spacing(0),
    paddingLeft: theme.spacing(0),
    paddingRight: theme.spacing(0),
    [theme.breakpoints.up("sm")]: {
      paddingLeft: theme.spacing(0),
      paddingRight: theme.spacing(0),
    },
  },
})
const Layout = ({ children, classes, noHeader }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
    render={data => (
      <Fragment>
        <Helmet
          title={data.site.siteMetadata.title}
          meta={[
            { name: "description", content: "Sample" },
            { name: "keywords", content: "sample, something" },
          ]}
          link={[
            {
              rel: "icon",
              type: "image/ico",
              sizes: "16x16",
              href: `${faviconIcon}`,
            },
          ]}
        >
          <html lang="en" />
        </Helmet>
        {!noHeader ? (
          <AuthLayout>{children}</AuthLayout>
        ) : (
          <AnonymousLayout>{children}</AnonymousLayout>
        )}
      </Fragment>
    )}
  />
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(Layout)
